module.exports = __webpack_public_path__ + "img/12.8e16d016.png";